"use client";
import MobileDropDown from "./mobile/MobileDropdow";
import PcDropdown from "./pc/PcDropdown";

interface Props {
  title: {
    Svg?: any;
    url?: string;
    text?: string;
    other?: any;
  };
  isMobile: boolean;
  down: boolean;
  onSelect?: (e: any) => void;
  children: any;
  reversed?: boolean;
  isFooter?: boolean;
  dropdown?: boolean;
  toggle?: boolean;
  HoverDropDownCollapseStyle?: React.CSSProperties;
}
const CommonDropdownMenu: React.FC<Props> = ({
  isMobile,
  title,
  children,
  down = true,
  onSelect,
  reversed = false,
  isFooter,
  dropdown = true,
  toggle = true,
  HoverDropDownCollapseStyle,
}) => {
  return isMobile || isFooter ? (
    <MobileDropDown
      title={title}
      onSelect={onSelect}
      isFooter={isFooter!}
      isMobile={isMobile}
      dropdown={dropdown}
      toggle={toggle}
    >
      {children}
    </MobileDropDown>
  ) : (
    <PcDropdown
      title={title}
      down={down}
      onSelect={onSelect}
      reversed={reversed}
      HoverDropDownCollapseStyle={HoverDropDownCollapseStyle}
    >
      {children}
    </PcDropdown>
  );
};

export default CommonDropdownMenu;
